module.exports = __webpack_public_path__ + "static/DENIED-29f06aaa5a04c96031edb604c9c57b22.png";